var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.2C0 2.32 0.72 1.6 1.6 1.6H12.8C13.2243 1.6 13.6313 1.76857 13.9314 2.06863C14.2314 2.36869 14.4 2.77565 14.4 3.2V14.4C14.4 14.8243 14.2314 15.2313 13.9314 15.5314C13.6313 15.8314 13.2243 16 12.8 16H1.6C1.17565 16 0.768687 15.8314 0.468629 15.5314C0.168571 15.2313 0 14.8243 0 14.4V3.2ZM1.6 4.8V14.4H12.8V4.8H1.6ZM3.2 0H4.8V1.6H3.2V0ZM9.6 0H11.2V1.6H9.6V0ZM3.2 7.2H4.8V8.8H3.2V7.2ZM3.2 10.4H4.8V12H3.2V10.4ZM6.4 7.2H8V8.8H6.4V7.2ZM6.4 10.4H8V12H6.4V10.4ZM9.6 7.2H11.2V8.8H9.6V7.2ZM9.6 10.4H11.2V12H9.6V10.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWhite);
export default __webpack_public_path__ + "static/media/calendarWhite.3f8bdcefb2b24818f5b3bdec63c03cd5.svg";
export { ForwardRef as ReactComponent };